
import { approveDealershipRequest, deleteDealership, getAllDealership, updateDealership } from '../../redux/actions/AllActions';
import React, { useEffect, useState } from 'react';
import { Button, Image, Layout, message, Modal, Select, Space, Switch, Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getAllFranchaise } from '../../redux/actions/AllActions'
import { Content } from 'antd/es/layout/layout';
import EditDealership from '../EditDealership/EditDealership';
import { Option } from 'antd/es/mentions';
import Loading from '../../components/Loading/Loading';
import DealershipDetails from '../../components/Deatails/DealershipDetails/DealershipDetails';
import Filter from '../../components/Filter/Filter';
import AddFranchise from '../Add/AddFranchise/AddFranchise';
import AddDealership from '../Add/AddDealership/AddDealership';



const Dealership = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
      const { data ,loading} = useSelector((state) => state.data);
    
    const [filteredItems, setFilteredItems] = useState([]);
    const [isEditingModelVisible, setIsEditingModelVisible] = useState(false);
    const [isCreateModelVisible, setIsCreateModelVisible] = useState(false);
    const [handleDetailsVisible, setHandleDetailsVisible] = useState(false);
    const [editingRecord, setEditingRecord] = useState(null);
   const [addDearshipModal, setAddDealershipModal] = useState(false);
    const [admin, setAdmin] = useState("");
    // Sync `data` from Redux store to local state

    useEffect(() => {
        const adminData = localStorage.getItem("admindata");
        try {
            const parsedData = JSON.parse(adminData);
            if (parsedData && typeof parsedData === "object") {
                setAdmin(parsedData);
            } else {
                console.error("Invalid admin data structure");
                localStorage.removeItem("admindata");
            }
        } catch (error) {
            console.error("Error parsing admin data:", error);
            localStorage.removeItem("admindata");
        }
    }, []);


    useEffect(() => {
        setFilteredItems(data);
    }, [data]);
    const fetch = () => {
        dispatch(getAllDealership());

    }


    useEffect(() => {
        fetch()
    }, [dispatch]);

    const handleEdit = (record) => {
        setEditingRecord(record);
        setIsEditingModelVisible(true);
    };

    const handleDelete = (record) => {
        Modal.confirm({
            title: 'Are you sure you want to delete this dealership?',
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            onOk: async () => {
                try {
                    const resp = await (deleteDealership(record._id));
                    if (resp?.data?.success) {
                        fetch();
                        message.success('Dealership deleted successfully');
                    } else {
                        message.error('Failed to delete user');
                    }
                } catch (error) {
                    message.error('An error occurred while deleting the user');
                }
            },
        });



    };

    const handleDetails = (record) => {
        setEditingRecord(record);
        setHandleDetailsVisible(true);
    };

    const handleEditCancel = () => {
        setIsEditingModelVisible(false);
    };



  const handleChangeStatus =async  (e,record) => {
        try {
            const response = await approveDealershipRequest(e, record?._id)
            dispatch(getAllDealership());
            message.success("Status Changed Successfully")
        } catch (e) {
            // alert("Changing Status of Franchise failed")
            message.error("Changing Status of Dealership failed")

        }
    }


    const columns = [
        {
            title: 'Business Name',
            dataIndex: 'businessName',
            key: 'businessName',
            width: 300,
        },
        {
            title: "Name ",
            dataIndex: 'user',
            key: 'status',
            width: 300,
            render: (_, record) => {
                return (<div>
                    {record?.user?.name}
                </div>)

            }
        },
        {
            title: "Email ",
            dataIndex: 'user',
            key: 'status',
            width: 300,
            render: (_, record) => {
                return (<div>
                    {record?.user?.email}
                </div>)

            }
        },
        {
            title: "Paid",
            dataIndex: 'isApproved',
            key: 'isApproved',
            width: 300,
            render: (_, record) => (<Space>
                {record?.payment_status === "paid" ?
                    <div
                        style={{
                            background: "green",

                            color: "white",
                            padding: "10px 20px",
                            borderRadius: "2px",
                            fontWeight: 'bold',
                            letterSpacing: "1px",
                            fontSize: "13px",
                            width: "120px",
                            textAlign: "center"
                        }}
                    >
                        Paid
                    </div>
                    : <div

                        style={{
                            background: "red",
                            color: "white",
                            padding: "10px 20px",
                            borderRadius: "2px",
                            fontWeight: 'bold',
                            letterSpacing: "1px",
                            fontSize: "13px",
                            width: "120px",
                            textAlign: "center"
                        }}
                    >
                        Not Paid
                    </div>
                }

            </Space>)
        },
        {
            title: "Approve",
            dataIndex: 'status',
            key: 'status',
            width: 300,
            render: (_, record) => (<Space>
                <div>
                    <Select
                        disabled={record?.payment_status !== 'paid' || record?.status === 'accepted'}
                        style={{
                            width: "100px"
                        }}
                        onChange={(e) => { handleChangeStatus(e, record) }}
                        value={record.status}>
                        <Option value="pending">Pending</Option>
                        <Option value="rejected">Reject</Option>
                        <Option value="accepted">Accept</Option>
                    </Select>
                </div>

            </Space>)
        },
        {
            title: 'Gst Number',
            dataIndex: 'gstNumber',
            key: 'gstNumber',
            width: 300,
        },
        {
            title: 'Entity Type',
            dataIndex: 'entityType',
            key: 'entityType',
            width: 300,
        },
        {
            title: 'Business Category',
            dataIndex: 'businessCategory',
            key: 'businessCategory',
            width: 300,
        },
        {
            title: 'Business Address',
            dataIndex: 'businessAddress',
            key: 'businessAddress',
            width: 300,
        },
        {
            title: 'Business Overview',
            dataIndex: 'businessOverview',
            key: '',
            width: 300,
        },
        {
            title: 'Business Photo Url',
            dataIndex: 'businessPhotoUrl',
            key: 'businessPhotoUrl',
            width: 300,
            render: (_, record) => (
                <Space>

                    {
                        // admin?.role === 'superAdmin' &&
                        <div
                            style={{
                                display: 'flex',
                                width: "100px"
                            }}
                        >
                            <Image

                                src={record?.businessPhotoUrl}
                            />

                        </div>
                    }     </Space>
            ),
        },

        {
            title: 'Logo Photo Url',
            dataIndex: 'logoPhotoUrl',
            key: 'logoPhotoUrl',
            width: 300,
            render: (_, record) => (
                <Space>

                    {
                        // admin?.role === 'superAdmin' &&
                        <div
                            style={{
                                display: 'flex',
                                width: "100px"
                            }}
                        >
                            <Image

                                src={record?.logoPhotoUrl}
                            />

                        </div>
                    }     </Space>
            ),
        },

        {
            title: 'franchise Fee',
            dataIndex: 'franchiseFee',
            key: 'franchiseFee',
            width: 300,
        },

        {
            title: 'Royalty Percentage',
            dataIndex: 'royaltyPercentage',
            key: 'royaltyPercentage',
            width: 300,
        },

        {
            title: 'RequiredArea Sq Ft',
            dataIndex: 'requiredAreaSqFt',
            key: 'requiredAreaSqFt',
            width: 300,
        },
        {
            title: 'Support Provided',
            dataIndex: 'supportProvided',
            key: 'supportProvided',
            width: 300,
        },
        {
            title: 'Territory Availability',
            dataIndex: 'territoryAvailability',
            key: 'territoryAvailability',
            width: 300,
        },

        {
            title: 'Actions',
            key: 'actions',
            render: (_, record) => (
                <Space
                
            
                >

                    {
                        // admin?.role === 'superAdmin' &&
                        <div
                            style={{
                                display: 'flex',
                                width: "200px",
                                
                                
                            }}
                        >
                            <Button type="link" onClick={() => handleEdit(record)}>
                                Edit
                            </Button>
                            <Button type="link" onClick={() => handleDetails(record)}>
                                Details
                            </Button>
                            <Button type="link" danger onClick={() => handleDelete(record)}>
                                Delete
                            </Button>

                        </div>
                    }     </Space>
            ),
                fixed : 'right'
        },
    ];


        
    



  return (
      <div>
          <div style={{
              margin : "20px 0"
          }}>
              <Button
                  onClick={() => setAddDealershipModal(true)}
              >+ Add Dealership</Button>
              </div>
          <Layout
              style={{

                  height: "82vh",
              }}
          >
              
              {
                  loading ?
                      <Loading /> :
                      <>
                          {/* <Content> */}
                              <Filter
                                  allData={data}
                                  setFilteredItems={setFilteredItems}
                                  searchKeys={['gst', 'territoryAvailability', 'businessName']}
                              />
                              <div >
                      <Table
                          columns={columns}
                          pagination={{ position: ['bottomCenter'], pageSize: 10 }}
                          dataSource={filteredItems}
                          rowKey={(record) => record._id}
                                      style={{ height: '80vh' }}
                                      scroll={{ x: 'max-content', y: 'calc(100vh - 300px)' }}
                      />
                  </div>
              {/* </Content> */}

              {/* Edit Dealership Modal */}
              <Modal
                  title="Edit Dealership"
                  open={isEditingModelVisible}
                  onCancel={handleEditCancel}
                  footer={null}
              >
                  {/* <EditUser editingRecord={editingRecord} /> */}

                              <EditDealership
                                  handleEditCancel={handleEditCancel}
                  editingRecord={editingRecord}
                      
                  />
              </Modal>

              {/* Dealership Modal */}
              <Modal
                  title="Dealership Details"
                  open={handleDetailsVisible}
                  onCancel={() => setHandleDetailsVisible(false)}
                  footer={null}
              >
                              
                                  <DealershipDetails
                                  dealership = {editingRecord}
                                  />
                  
                          </Modal>
                      </>
              }


          </Layout>

          <Modal
              title="Add Dealerhip"
              visible={addDearshipModal}
              onCancel={() => setAddDealershipModal(false)}
              footer={null}
          >
              <AddDealership setAddDealershipModal={setAddDealershipModal} />
          </Modal>
    </div>
  )
}

export default Dealership